import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginController from "../Admin/Controller/login_controller.ts";

function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    // Check if the user is authenticated by calling the backend API
    const checkAuth = async () => {
      try {
        const email = localStorage.getItem("email");
        if (!email) {
          navigate("/admin/login");
          return;
        }

        const data = { email };
        const response = await LoginController.authenticateRequest(data);
        console.log(response);
        if (response.message === "Authenticated") {
          setIsAuthenticated(true); // Set the flag to true if authenticated
        } else {
          navigate("/admin/login"); // Redirect to login if not authenticated
          localStorage.clear(); // Clear all data in localStorage
        }
      } catch (error) {
        console.error("Error checking authentication:", error);
        navigate("/admin/login"); // Redirect to login on error
      }
    };

    checkAuth();
  }, []);

  // Only render children if authenticated
  return isAuthenticated ? children : null;
}

export default ProtectedRoute;
